import axios from 'axios'

// state
const state = {
    data: {
        "recept_toDay": 0,
        "recept_yesterday": 0,
        "series": [],
        "series2": [],
        "series3": [],
        "year": 0,
        "last_reception": [],
        "drilldown": [],
        "totalSemuaPenerimaan": 0,
        "target": 0,
        "name_month": '',
        "tableMaster": [],
        "tableMasterFoot": {
            'targetAnggaran': 0,
            'bulanSekarang': 0,
            'bulanLalu': 0,
            'bulanTotal': 0,
            'persen': 0,
        }
    }
}
// getters
const getters = {
    data: state => state.data
}


// mutations
export const mutations = {
    setData(state, data) {
        state.data = data;
    }
}

// actions
export const actions = {
    async setData({
        commit
    }, { year }) {
        const {
            data
        } = await axios.get('/api/v1/dashboard' + '?year=' + year)
        commit('setData', data);
    }
}

export const dashboard = {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};